import { Component, Input } from '@angular/core';
import { ProfileDisplayComponent } from '@shared/components/profile-display/profile-display.component';
import { CommonModule } from '@angular/common';
import { size } from 'lodash';

export interface MultipleProfileDisplay {
  unit: 'person' | 'department';
  display: { [k: string]: any };
}
@Component({
  selector: 'app-multiple-profile-display',
  standalone: true,
  templateUrl: './multiple-profile-display.component.html',
  styleUrls: ['./multiple-profile-display.component.scss'],
  imports: [CommonModule, ProfileDisplayComponent],
})
export class MultipleProfileDisplayComponent {
  @Input() count = 3;
  @Input() showingDisplay = 3;
  @Input() size = 24;
  @Input() fontSize: number;
  @Input() overlapSize: number;

  _displayList: MultipleProfileDisplay[] = [];
  @Input() set displayList(displayList: MultipleProfileDisplay[]) {
    this._displayList = displayList.slice(0, this.showingDisplay);
  }

  get notOverlapSize(): number {
    return this.size - (this.overlapSize || this.size * 0.33);
  }

  get showCount(): boolean {
    return this.count > this.showingDisplay;
  }
}
